import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function FesteStunden() {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  const { tagessoll, arbeitstage, stundenloehner } =
    form.state.values.bezahlung.arbeitszeitkonto;
  const bezahlungsart = form.state.values.bezahlung.bezahlungsart.art;

  const stundenFieldDisabled =
    (arbeitstage.length > 0 && bezahlungsart === 'fixgehalt') ||
    (bezahlungsart === 'stunden' &&
      stundenloehner.richtwertEinheit === 'exakt');

  useEffect(() => {
    if (stundenFieldDisabled) {
      form.setFieldValue(
        'abwesenheiten.allgemein.stunden',
        form.getFieldValue('bezahlung.arbeitszeitkonto.tagessoll'),
      );
    }
  }, []);

  return (
    <div className="flex flex-col gap-1">
      <form.AppField
        name="abwesenheiten.allgemein.stunden"
        defaultValue={tagessoll ?? undefined}>
        {(field) => (
          <field.HoursInput
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
            )}
            disabled={stundenFieldDisabled}
            isRequired
            maxHours={24}
            placeholder="hh:mm"
            suffix={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.suffix',
            )}
          />
        )}
      </form.AppField>
      {stundenFieldDisabled && (
        <span className="text-neutrals-700 text-xs font-normal leading-4">
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.notEditableDescription',
          )}
        </span>
      )}
    </div>
  );
}
